/// <amd-module name="VSS/Features/History" />
export { PageStateHistoryService } from "./PageStateHistoryService/PageStateHistoryService";
export {
    HistoryBehavior,
    IPageHistoryBasicFilterField,
    IPageHistoryFilterField,
    IPageHistoryObjectFilterField,
    IPageStateHistoryService
} from "./PageStateHistoryService/PageStateHistoryService.types";
